module.exports = __webpack_public_path__ + "static/media/canva.0397c10e.svg";